import { Phone, Mail, MessageCircle } from 'lucide-react';

export interface ContactLinkProps {
    type: 'phone' | 'email' | 'whatsapp';
    value: string;
    label?: string;
    showIcon?: boolean;
    className?: string;
}

const typeConfig = {
    phone: {
        icon: Phone,
        getHref: (value: string) => `tel:${value.replace(/\./g, '')}`,
        formatValue: (value: string) => value,
    },
    email: {
        icon: Mail,
        getHref: (value: string) => `mailto:${value}`,
        formatValue: (value: string) => value,
    },
    whatsapp: {
        icon: MessageCircle,
        getHref: (value: string) => `https://wa.me/40${value.replace(/\./g, '').replace(/^0/, '')}`,
        formatValue: (value: string) => value,
    },
};

export function ContactLink({ type, value, label, showIcon = true, className = '' }: ContactLinkProps) {
    const config = typeConfig[type];
    const Icon = config.icon;

    return (
        <a
            href={config.getHref(value)}
            target={type === 'whatsapp' ? '_blank' : undefined}
            rel={type === 'whatsapp' ? 'noopener noreferrer' : undefined}
            className={`inline-flex items-center gap-2 text-green-600 hover:text-green-800 transition-colors ${className}`}
        >
            {showIcon && <Icon className="w-4 h-4" />}
            <span>{label || config.formatValue(value)}</span>
        </a>
    );
}
